import { createAsyncThunk } from '@reduxjs/toolkit';

import { getPaginationRequest } from 'src/ts/interfaces';
import api from './api';
import { NAME } from './constants';

export const rentVerificationGetAllThunk = createAsyncThunk(
  `${NAME}/getAll`,
  async (filters: getPaginationRequest) => {
    return await api.getAll(filters);
  }
);
